
import $ from 'jquery';

const accordion = (() => {
  const arrowDownBtn = () => {
    // $(".arrow-down-btn").on("click", function(){
    //   $('body,html').animate({ scrollTop: $(this).parents("section").next("section").offset().top}, 800);
    // });
  };
  const defaultAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        accordionContent.classList.toggle('js-active');
      });
    }
  };

  const careerAnim = () => {
    if ($('.home-career').is(":visible")){
      var targetScroll = $('.home-career').position().top;
      if($(window).scrollTop() > targetScroll - 400) {
        $('.home-career').addClass("pos-active");
      }
      $(window).scroll(function() {
        var targetScroll = $('.home-career').position().top;
        if($(window).scrollTop() > targetScroll - 400) {
          $('.home-career').addClass("pos-active");
        }
      });
    }
  }

  const stickyArrow = () => {
    var scrollTopButton = document.getElementById("scrollTopBtn");

    window.onscroll = function() {
        scrollFunction();
    };

    function scrollFunction() {
        if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
            scrollTopButton.classList.add("active");
        } else {
            scrollTopButton.classList.remove("active");
        }
    }
    scrollTopButton.addEventListener("click", scrollToTop); 
    function scrollToTop() {
        scrollToTopAnimation();
    }

    function scrollToTopAnimation() {
        var currentPosition = document.documentElement.scrollTop || document.body.scrollTop;

        if (currentPosition > 0) {
            window.requestAnimationFrame(scrollToTopAnimation);
            window.scrollTo(0, currentPosition - currentPosition / 8);
        }
    }
  }

  const init = () => {
    arrowDownBtn();
    defaultAccordion();
    careerAnim();
    stickyArrow();
  };

  return {
    init,
  };
})();

export default accordion;
